<zxing-scanner *ngIf="scannerEnabled" #scanner [enable]="true" (scanSuccess)="scanSuccessHandler($event)"
    [formats]="formatsEnabled">
</zxing-scanner>

<div *ngIf="!scannerEnabled" class="container qr-code-container">
    <h4> {{memoryCode}}</h4>
</div>